<script>
    import { clickOutside } from "$/utils/clickOutside.js";
    import { tooltip } from "$/utils/tooltip";
    import { ActiveTopicStore } from "$/stores/extension/ActiveTopicStore";
    import { addHttpsToUrl } from "$/utils/Utils";
    import { isValidUrl } from "$/utils/upload";
    import { AppStore } from "$/stores/AppStore";

    export let addLink = false;

    let pageUrl = "";
    let errorMessage = "";
    let loader = false;

    function validateUrl() {
        let trimmedUrl = pageUrl.trim();
        if (isValidUrl(trimmedUrl) || trimmedUrl === "") {
            errorMessage = "";
        } else {
            errorMessage = "We couldn’t recognize that as a valid link";
        }
    }

    async function addSnippetFromUrl() {
        validateUrl();
        if (errorMessage) return;
        loader = true;

        try {
            let snippet = await ActiveTopicStore.createSnippetFromURL(
                addHttpsToUrl(pageUrl.trim()),
            );
            addLink = false;
            pageUrl = "";
            AppStore.setFocused({ snippetId: snippet.id });
        } catch (e) {
            errorMessage = "Looks like the link doesn’t work";
        }

        loader = false;
    }
</script>

<div
        class="add-link"
        use:clickOutside
        on:click_outside={() => (addLink = false)}
>
    {#if addLink}
        <div
                class="add-link-menu"
                draggable="false"
                on:dragstart|stopPropagation|preventDefault
                on:drag|stopPropagation|preventDefault
                on:dragend|stopPropagation|preventDefault
        >
            <div class="input-container {errorMessage ? 'error' : ''}">
                <input
                        type="text"
                        bind:value={pageUrl}
                        class="add-link-input"
                        disabled={loader}
                        on:keydown={(e) => {
                        if (e.key === "Enter") addSnippetFromUrl();
                        else if (e.key === "Escape") addLink = false;
                    }}
                        placeholder="Enter link to generate snippet..."
                        autofocus
                />
                {#if errorMessage}
                    <svg
                            class="invalid-link"
                            use:tooltip={errorMessage}
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke-width="1.5"
                            stroke="currentColor"
                            on:click|stopPropagation
                    >
                        <path
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126ZM12 15.75h.007v.008H12v-.008Z"
                        />
                    </svg>
                {/if}
            </div>
            <div class="add-link-actions">
                <button
                        class="add-link-item"
                        on:click={() => {
                        addLink = false;
                        pageUrl = "";
                    }}
                >
                    Cancel
                </button>
                <button
                        class="add-link-item"
                        on:click={addSnippetFromUrl}
                        disabled={loader}
                >
                    <span class="open-button__loading--text">
                        {loader ? "Saving" : "Save"}
                    </span>
                    <div class="open-button__loading" class:hidden={!loader}>
                        <svg
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke-width="1.5"
                                stroke="currentColor"
                                class="size-4"
                        >
                            <path
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0l3.181 3.183a8.25 8.25 0 0013.803-3.7M4.031 9.865a8.25 8.25 0 0113.803-3.7l3.181 3.182m0-4.991v4.99"
                            />
                        </svg>
                    </div>
                </button>
            </div>
        </div>
    {/if}
</div>

<style>
    .add-link {
        @apply reset relative z-10 flex !important;
    }

    .add-link::before {
        @apply hidden !important;
    }

    .add-link-menu {
        @apply reset absolute -top-4 right-2 z-50 flex w-[280px] flex-col rounded-md border border-solid border-gray-200 bg-white p-1 shadow-md !important;
    }

    .input-container {
        @apply reset relative flex w-full bg-gray-100 !important;
    }

    .input-container.error {
        @apply bg-pink-100 !important;
    }

    .invalid-link {
        @apply reset absolute right-2 top-1/2 h-5 w-5 -translate-y-1/2 transform text-pink-500 !important;
    }

    .add-link-input {
        @apply reset relative grow bg-gray-100 px-2 py-1 text-xs focus:outline-none !important;
    }

    .add-link-actions {
        @apply reset mb-0 mt-1 flex justify-end !important;
    }

    .add-link-item {
        @apply reset flex cursor-pointer items-center justify-center whitespace-nowrap rounded px-2 py-1 text-xs hover:bg-gray-200 !important;
    }

    .open-button__loading {
        @apply ml-1 animate-spin !important;
    }
</style>